import { useEditTransaction } from "@/components/EditTransaction/state.ts";
import { useSidePanelState } from "@/components/SidePanel/state.ts";
import EditTransaction from "@/components/EditTransaction/TransactionForm.vue";
import type Transaction from "@/classes/Transaction.ts";

const onEdit = (id: number, type: "expense" | "income") => {
  const sidePanelState = useSidePanelState();
  const state = useEditTransaction();

  sidePanelState.open(EditTransaction, {
    componentProps: { type, id },
    title: `${type === "expense" ? "Uitgave" : "Inkomen"} bewerken`,
    onClose: () => state.$reset(),
  });
};

// One display row per one-off; occurrences of the same recurring series stay together in a
// single row so a monthly item reads as one line across periods, not one line per occurrence.
const displayRows = (transactions: Transaction[]): Transaction[][] => {
  const series = new Map<string, Transaction[]>();
  const rows: Transaction[][] = [];

  for (const tx of transactions) {
    if (tx.recurrence !== null) {
      const key = `${tx.group?.id ?? ""}:${tx.recurrence.toString()}`;
      const bucket = series.get(key);

      if (bucket) {
        bucket.push(tx);
      } else {
        series.set(key, [tx]);
      }
    } else {
      rows.push([tx]);
    }
  }

  return [...rows, ...series.values()].sort((a, b) => a[0].date.valueOf() - b[0].date.valueOf());
};

export { displayRows, onEdit };
